<template>
  <v-card outlined class="my-3">
    <v-row class="py-2">
      <v-col cols="12" md="3">
        <p class="mb-0">
          <span>Subtotal:</span>
          {{ subtotal | currency }}
        </p>
      </v-col>
      <v-col cols="12" md="3">
        <p class="mb-0">
          <span>I.V.A.:</span>
          {{ iva | currency }}
        </p>
      </v-col>
      <v-col cols="12" md="3">
        <p class="mb-0">
          <span class="font-weight-bold">Total:</span>
          {{ total | currency }}
        </p>
      </v-col>
      <v-col cols="12" md="3" class="d-flex">
        <v-menu offset-y v-if="items.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="warning" v-bind="attrs" v-on="on" icon x-small>
              <v-icon>mdi-alert</v-icon>
            </v-btn>
          </template>
          <v-card max-width="320">
            <v-card-title class="warning white--text">
              Advertencia
            </v-card-title>
            <v-card-text>
              <p class="text-subheading-1 text-justify mt-4">
                Los siguientes productos no tienen un dato de peso. Por lo
                tanto,
                <span class="font-weight-bold">
                  no se considerarán en el cálculo del peso total.</span
                >
              </p>
              <v-list>
                <v-list-item v-for="(item, index) in items" :key="index">
                  <v-list-item-title>{{ item.descripcion }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>
        <p class="mb-0">
          <span class="font-weight-bold">Peso Total:</span>
          {{ pesoTotal | number }} KG
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  computed: {
    pesoTotal() {
      return this.$store.state.pesoTotal;
    },
    total() {
      return this.$store.state.total;
    },
    subtotal() {
      return this.$store.state.subtotal;
    },
    iva() {
      return this.$store.state.iva;
    },
    items() {
      return this.$store.state.warningsPeso;
    },
  },
};
</script>